import panguFormPage from './panguFormPage'
export default panguFormPage
